import { OnInit, ChangeDetectorRef, OnDestroy, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Selectors, Actions as RootActions } from 'store/root-reducer';
import { Actions, ofType } from '@ngrx/effects';
import { ReplaySubject, combineLatest } from 'rxjs';
import { takeUntil, map } from 'rxjs/operators';
import { RecordType } from 'modules/shared/models/record.models';
import * as CustomerActions from 'store/actions/customer.actions';
import { SearchActionTypes } from 'store/actions/search.actions';
import { DetailsFormComponent } from 'modules/customers/components/details-form/details-form.component';
import { CrpRoleComponent } from 'modules/customers/components/crp-role/crp-role.component';
var CrpAddPage = /** @class */ (function () {
    function CrpAddPage(activatedRoute, cdRef, store, actions$) {
        this.activatedRoute = activatedRoute;
        this.cdRef = cdRef;
        this.store = store;
        this.actions$ = actions$;
        this.unsubscribe$ = new ReplaySubject(1);
        this.detailFormOption = {};
        this.individualFormValid = false;
        this.corporateFormValid = false;
        this.breadcrumbs = [];
        this.formLoading = false;
        this.triedSubmit = false;
    }
    CrpAddPage.prototype.ngOnInit = function () {
        var _this = this;
        this.getLoadingStatus();
        this.store.select(Selectors.customer.getCustomer).pipe(takeUntil(this.unsubscribe$)).subscribe(function (customer) {
            if (customer) {
                _this.customer = customer;
                _this.detailFormOption.exclude_customer_id = customer.id;
                _this.loadBreadcrumbs(customer.id, customer.name);
                _this.cdRef.markForCheck();
            }
        });
    };
    CrpAddPage.prototype.ngAfterViewInit = function () {
        this.activatedRoute
            .fragment
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(function (fragment) {
            if (fragment) {
                document.querySelector('#' + fragment).scrollIntoView();
            }
        });
    };
    /**
     * Get loading status from store
     * @method getLoadingStatus
     */
    CrpAddPage.prototype.getLoadingStatus = function () {
        this.loading$ = combineLatest([
            this.store.select(Selectors.customer.getLoading),
            this.store.select(Selectors.search.getLoading)
        ]).pipe(takeUntil(this.unsubscribe$), map(function (_a) {
            var customerLoading = _a[0], searchLoading = _a[1];
            return customerLoading.includes(CustomerActions.CustomerActionTypes.CREATE_AND_RA_CRP) ||
                customerLoading.includes(CustomerActions.CustomerActionTypes.CREATE_AND_ADD_CRP) ||
                customerLoading.includes(CustomerActions.CustomerActionTypes.CREATE_OR_UPDATE_CRP) ||
                searchLoading.includes(SearchActionTypes.POST_SCREENING);
        }));
    };
    CrpAddPage.prototype.loadBreadcrumbs = function (customerId, customerName) {
        this.breadcrumbs = [
            {
                url: '/customers',
                label: 'Customer List'
            }, {
                url: "/customers/" + customerId,
                label: customerName
            }, {
                url: "/customers/" + customerId + "/edit/crp-add",
                label: 'Add CRP'
            }
        ];
        this.cdRef.detectChanges();
    };
    /**
     * Inits observables for getting add crp success status
     * @method getAddCrpSuccessStatus
     */
    CrpAddPage.prototype.getAddCrpSuccessStatus = function () {
        var _this = this;
        this.actions$.pipe(ofType(CustomerActions.CustomerActionTypes.CREATE_OR_UPDATE_CRP_SUCCESS), takeUntil(this.unsubscribe$))
            .subscribe(function () {
            _this.store.dispatch(new RootActions.customer.GetCustomerStatus({
                customerId: _this.customer.id
            }));
            _this.resetForms();
        });
    };
    CrpAddPage.prototype.isFormValid = function () {
        return (this.customerType === RecordType.INDIVIDUAL && this.individualFormValid) ||
            (this.customerType === RecordType.CORPORATE && this.corporateFormValid);
    };
    /**
     * Check if user has entered any alias name or former registered name
     * @method hasFormerOrAliasName
     */
    CrpAddPage.prototype.hasFormerOrAliasName = function () {
        if (this.customerType === RecordType.INDIVIDUAL) {
            return this.individualForm.aliasNames.length || this.individualForm.oldNames.length;
        }
        else if (this.customerType === RecordType.CORPORATE) {
            return this.corporateForm.aliasNames.length || this.corporateForm.oldNames.length;
        }
        return false;
    };
    CrpAddPage.prototype.isRoleProvided = function () {
        return !!this.crpRoleComponent.getCrpRoles().length;
    };
    CrpAddPage.prototype.updateCustomer = function (subaction) {
        this.triedSubmit = true;
        this.cdRef.detectChanges();
        if (this.isFormValid() && this.isRoleProvided()) {
            var recordPayload = void 0;
            var crpDataToSend = void 0;
            if (this.customerType === RecordType.INDIVIDUAL) {
                recordPayload = {
                    title: this.individualForm.title,
                    name: this.individualForm.name,
                    aliasNames: this.individualForm.aliasNames,
                    oldNames: this.individualForm.oldNames,
                    nationality: this.individualForm.nationality,
                    countryOfResidence: this.individualForm.countryOfResidence,
                    gender: this.individualForm.gender,
                    dateOfBirth: this.individualForm.dateOfBirth,
                    industry: this.individualForm.industry,
                    occupation: this.individualForm.occupation,
                    addresses: this.individualForm.addresses,
                    phoneNumbers: this.individualForm.phoneNumbers,
                    referenceId: this.individualForm.recordReferenceId,
                    sourceOfFunds: this.individualForm.sourceOfFunds,
                    emailAddresses: this.individualForm.emailAddresses,
                    bankAccounts: this.individualForm.bankAccounts,
                    countryOfBirth: this.individualForm.countryOfBirth,
                    idType: this.individualForm.idType,
                    idNumber: this.individualForm.idNumber,
                    idIssueDate: this.individualForm.idIssueDate,
                    idExpiryDate: this.individualForm.idExpiryDate,
                    isUndischargedBankrupt: this.individualForm.isUndischargedBankrupt,
                };
                if (this.recordId) {
                    recordPayload['id'] = this.recordId;
                }
                crpDataToSend = {
                    primary: false,
                    status: this.individualForm.status,
                    roles: this.crpRoleComponent.getCrpRoles(),
                    individualRecord: recordPayload
                };
            }
            if (this.customerType === RecordType.CORPORATE) {
                recordPayload = {
                    isIncorporated: !!this.corporateForm.isIncorporated,
                    name: this.corporateForm.name,
                    aliasNames: this.corporateForm.aliasNames,
                    oldNames: this.corporateForm.oldNames,
                    entityType: this.corporateForm.entityType,
                    ownershipStructureLayers: this.corporateForm.ownershipStructureLayers,
                    countryOfIncorporation: this.corporateForm.countryOfIncorporation,
                    countryOfOperations: this.corporateForm.countryOfOperations,
                    businessActivity: this.corporateForm.businessActivity,
                    addresses: this.corporateForm.addresses,
                    phoneNumbers: this.corporateForm.phoneNumbers,
                    referenceId: this.corporateForm.recordReferenceId,
                    sourceOfFunds: this.corporateForm.sourceOfFunds,
                    emailAddresses: this.corporateForm.emailAddresses,
                    bankAccounts: this.corporateForm.bankAccounts,
                    incorporationNumber: this.corporateForm.incorporationNumber,
                    website: this.corporateForm.website,
                    incorporationDate: this.corporateForm.incorporationDate,
                    incorporationExpiryDate: this.corporateForm.incorporationExpiryDate,
                    isUndischargedBankrupt: this.corporateForm.isUndischargedBankrupt,
                    imoNumber: this.corporateForm.imoNumber
                };
                if (this.recordId) {
                    recordPayload['id'] = this.recordId;
                }
                crpDataToSend = {
                    primary: false,
                    status: this.corporateForm.status,
                    roles: this.crpRoleComponent.getCrpRoles(),
                    corporateRecord: recordPayload
                };
            }
            if (subaction === 'ra') {
                this.store.dispatch(new RootActions.billable.CheckBalance({
                    actions: [
                        new RootActions.customer.CreateAndRACrp({
                            crpData: crpDataToSend,
                            customer: this.customer,
                            mode: 'CREATE'
                        })
                    ]
                }));
            }
            else if (subaction === 'crp') {
                this.store.dispatch(new RootActions.customer.CreateAndAddCrp({
                    crpData: crpDataToSend,
                    customer: this.customer,
                    mode: 'CREATE'
                }));
            }
            else {
                this.store.dispatch(new RootActions.customer.CreateOrUpdateCrp({
                    crpData: crpDataToSend,
                    customer: this.customer,
                    mode: 'CREATE'
                }));
            }
            this.getAddCrpSuccessStatus();
        }
    };
    CrpAddPage.prototype.resetForms = function () {
        this.triedSubmit = false;
        this.cdRef.detectChanges();
        this.detailForm.resetForms();
        this.crpRoleComponent.clearFormAndTable();
    };
    CrpAddPage.prototype.formChange = function (data) {
        this.individualForm = data.individualForm;
        this.corporateForm = data.corporateForm;
        this.customerType = data.customerType;
        this.individualFormValid = data.individualFormValid;
        this.corporateFormValid = data.corporateFormValid;
        this.recordId = data.recordId;
    };
    /**
     * update form loading status
     * @method formLoadingHandler
     */
    CrpAddPage.prototype.formLoadingHandler = function (formLoading) {
        this.formLoading = formLoading;
    };
    CrpAddPage.prototype.ngOnDestroy = function () {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        this.store.dispatch(new RootActions.customer.ResetCustomerOverview());
        this.store.dispatch(new RootActions.record.ResetRecord());
    };
    return CrpAddPage;
}());
export { CrpAddPage };
